import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/domains';
import { AxiosApi } from '@digibricks/plugin-axios';
import { ErrorResultHandler } from '@lib/domain-common';
import { Pagination } from '../../../core/domain/models';
export var SKILL_API = 'SKILL_API';
export var SkillApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(SkillApi, _AxiosApi);

  var _super = _createSuper(SkillApi);

  function SkillApi(axiosInstance, skillMapper) {
    var _this;

    _classCallCheck(this, SkillApi);

    _this = _super.call(this, 'skills', axiosInstance);
    _this.axiosInstance = axiosInstance;
    _this.skillMapper = skillMapper;
    return _this;
  }

  _createClass(SkillApi, [{
    key: "getSkills",
    value: function () {
      var _getSkills = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var jsonResponse, parsedResponseBody, skills, _iterator, _step, dto, skillResult, paginationResult;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.axios.get(this.url, {
                  params: {
                    limit: query.limit || 20,
                    nextToken: query.nextToken
                  }
                });

              case 3:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;
                skills = [];
                _iterator = _createForOfIteratorHelper(parsedResponseBody.data.items);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    dto = _step.value;
                    skillResult = this.skillMapper.toDomain(dto);

                    if (skillResult.isSuccess) {
                      skills.push(skillResult.getValue());
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                paginationResult = Pagination.create({
                  items: skills,
                  nextToken: parsedResponseBody.data.nextToken
                });

                if (!paginationResult.isFailure) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", Result.fail(paginationResult.error));

              case 11:
                return _context.abrupt("return", Result.ok(paginationResult.getValue()));

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 14]]);
      }));

      function getSkills(_x) {
        return _getSkills.apply(this, arguments);
      }

      return getSkills;
    }()
  }, {
    key: "getSkillById",
    value: function () {
      var _getSkillById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        var url, jsonResponse, parsedResponseBody, skillResult;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                url = "".concat(this.url, "/").concat(id);
                _context2.next = 4;
                return this.axios.get(url);

              case 4:
                jsonResponse = _context2.sent;
                parsedResponseBody = jsonResponse.data;
                skillResult = this.skillMapper.toDomain(parsedResponseBody.data);

                if (!skillResult.isFailure) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", Result.fail(skillResult.error));

              case 9:
                return _context2.abrupt("return", Result.ok(skillResult.getValue()));

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 12]]);
      }));

      function getSkillById(_x2) {
        return _getSkillById.apply(this, arguments);
      }

      return getSkillById;
    }()
  }]);

  return SkillApi;
}(AxiosApi);